import { useContentByComponentKey } from '@ynap/content-hook';
import { useAppState } from '@ynap/immutables-provider';

export const useDeliveryInfo = (_, fullFilledBy) => {
    const { locale } = useAppState() || {};

    if (!fullFilledBy) {
        return {
            deliveryInfo: null,
            error: null,
            deliveryLink: `/${locale}/content/help/delivery`,
            returnsLink: `/${locale}/content/help/exchanges-and-returns`,
        };
    }

    const { content } = useContentByComponentKey({
        componentKey: `${fullFilledBy.toLowerCase()}-delivery-and-returns-policy`,
        normalize,
    });

    return {
        dropshipInfo: content,
        deliveryLink: `/${locale}/content/help/delivery`,
        returnsLink: `/${locale}/content/help/exchanges-and-returns`,
    };
};

const normalize = ({ content }) =>
    content?.[0]?.items?.map(({ ynapParameter, teaser }) => ({ icon: ynapParameter, text: teaser?.teaserText })) || null;
